export enum TabsEnum {
  QUICKLINKS = 0,
  CATALOGUE = 1
}
